import React from "react";
import { Box, HStack, VStack, Text, Icon } from "@chakra-ui/react";
import { FaComments } from "react-icons/fa";

export default function TicketDescription({ ticket, colorScheme, cardPadding, MotionBox }) {
  return (
    <MotionBox
      bg={colorScheme.cardBg}
      borderRadius="2xl"
      shadow="xl"
      border="1px solid"
      borderColor={colorScheme.borderColor}
      overflow="hidden"
      _hover={{ shadow: "2xl", transform: "translateY(-1px)" }}
      sx={{ transition: "all 0.3s ease" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
    >
      <Box bgGradient={colorScheme.headerBg} px={cardPadding} py={{ base: 4, md: 5 }} position="relative">
        <Box
          position="absolute"
          top={0}
          right={0}
          width="100px"
          height="100px"
          bgGradient="radial(circle, whiteAlpha.100 0%, transparent 70%)"
          pointerEvents="none"
        />
        <HStack spacing={4}>
          <Box bg="whiteAlpha.200" p={3} borderRadius="lg" backdropFilter="blur(10px)">
            <Icon as={FaComments} color="white" boxSize={6} />
          </Box>
          <VStack align="start" spacing={1}>
            <Text color="white" fontSize="xl" fontWeight="bold">
              Açıklama
            </Text>
            <Text color="whiteAlpha.800" fontSize="sm">
              Ticket detay bilgileri
            </Text>
          </VStack>
        </HStack>
      </Box>

      <Box p={cardPadding}>
        <Text
          color={colorScheme.textColor}
          lineHeight="1.8"
          fontSize="md"
          fontWeight="medium"
          bg={colorScheme.descriptionBg}
          p={6}
          borderRadius="xl"
          border="1px solid"
          borderColor={colorScheme.descriptionBorderColor}
        >
          {ticket.body || "Açıklama bulunmuyor."}
        </Text>
      </Box>
    </MotionBox>
  );
}